import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
  FormModal,
  Input,
  Button,
  FormModalTitle,
  FormModalContent,
  FormModalActions,
  ConfirmModal,
  Typography,
} from 'sputnik-ui'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useDispatch } from 'react-redux'
import { addThirdPartyCamera } from 'features/Cameras/camerasSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { fetchAvailable } from 'features/Devices/installationsSlice'
import { copyToClipboard } from 'utils/helpers'
import { showInfoMessage } from 'store/ui/actions'
import { Box } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import RtspLinkExplain from 'components/atoms/RtspLinkExplain'

const validationSchema = yup.object().shape({
  alias: yup.string().max(60).required(),
  rtsp_link: yup.string().required(),
})

export default function AddThirdPartyCameras({
  open,
  handleClose,
  onSuccess,
  ...props
}) {
  const dispatch = useDispatch()

  const formik = useFormik({
    validationSchema,
    initialValues: {
      alias: '',
      rtsp_link: '',
      kind: 'camera',
    },
    onSubmit: (val) => {
      dispatch(addThirdPartyCamera(val))
        .then(unwrapResult)
        .then((el) => {
          onSuccess(el?.serial_number)
          handleClose()
        })
        .then(() => dispatch(fetchAvailable({ q: '' })))
    },
  })

  const { t } = useTranslation(['common', 'device', 'info'])

  return (
    <form onSubmit={formik.handleSubmit}>
      <FormModalTitle>
        {t('devices:cameras.third_party.helper.addition')}
      </FormModalTitle>
      <FormModalContent label={t('devices:cameras.third_party.info')}>
        <Input
          required
          name="rtsp_link"
          value={formik.values.rtsp_link}
          label={t('devices:cameras.third_party.rtsp')}
          onChange={formik.handleChange}
          error={formik.errors && formik.errors.rtsp_link}
          fullWidth
          style={{ marginBottom: 24 }}
        />
        <Input
          required
          name="alias"
          value={formik.values.alias}
          onChange={formik.handleChange}
          error={formik.errors && formik.errors.alias}
          label={t('devices:cameras.third_party.alias')}
          fullWidth
        />
        <RtspLinkExplain
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: 32,
          }}
        />
      </FormModalContent>
      <FormModalActions>
        <Button
          variant="v2"
          primary
          fullWidth
          type="submit"
          disabled={
            !(
              formik.values.alias &&
              formik.values.rtsp_link &&
              !formik.errors.rtsp_link &&
              !formik.errors.alias
            )
          }
        >
          {t('devices:cameras.add')}
        </Button>
      </FormModalActions>
    </form>
  )
}
